export enum BackendErrorErrorMessage {
    WrongToken = 'Błędny token',
    ExpiredAccount = 'Data ważności konta wygasła. Skontaktuj się z administratorem systemu.',
    WrongEmailCode = 'Błędny adres e-mail',
    WrongPesel = 'Niezgodny nr PESEL'
}

export enum BackendErrorCode {
    WrongToken = 'WrongToken',
    ExpiredAccount = 'ExpiredAccount',
    WrongEmail = 'WrongEmail',
    WrongPesel = 'WrongPesel'
}

export type ErrorCode = BackendErrorCode;